import { FC } from "react"
import { Button as MarmaladeButton } from "@eventbrite/marmalade"

// types
import { ButtonProps } from "@eventbrite/marmalade/lib/components/Button/Button"

export type Props = React.DetailedHTMLProps<
  React.ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
> &
  ButtonProps & {
    children: React.ReactNode
  }

export const Button: FC<Props> = ({ children, ...buttonProps }) => {
  return <MarmaladeButton {...buttonProps}>{children}</MarmaladeButton>
}
